/**
*****************************************
*										                    *
* NAGARRO  - CSX - CONFIDENTIAL         *
*										                    *
*****************************************
*/
import { Component, OnDestroy, OnInit } from '@angular/core';

import { ConfigService } from './../../core/services/config.service';
import { EditModeService } from './../../core/services/edit-mode.service';
import { LmsBaseAppComponent } from '../../core/component/base-app/lms-base-app.component';
import { LmsMenuService } from './../../core/services/lms-menu.service';
import { LmsModuleService } from './../../core/services/lms-module.service';
import { NotesDataService } from './../../shared/services/note-data.service';
import { PopupService } from '../../core/services/popup.service';
import { RouteChangePopupService } from './../../core/services/route-change-popup.service';
import { UtilService } from './../../core/services/util.service';
import { PermitAll } from '@csx/security';

/**
 * @export
 * @class LmsTrainNotesComponent
 * @extends {LmsBaseAppComponent}
 * @implements {OnInit}
 */
@Component({
  selector: 'lms-train-notes',
  templateUrl: './train-notes.component.html',
  styleUrls: ['./train-notes.component.scss']
})
@PermitAll()
export class LmsTrainNotesComponent extends LmsBaseAppComponent implements OnInit, OnDestroy {
  configdata: any;
  blankMessage: any;
  errorMessage: any;
  noteTextParent: string;

  /**
   * Creates an instance of LmsTrainNotesComponent.
   * @param {NotesDataService} notesDataService
   * @param {ConfigService} configService
   * @param {LmsMenuService} lmsMenuService
   * @param {LmsModuleService} lmsModuleService
   * @param {UtilService} utilService
   * @param {EditModeService} editModeService
   * @param {RouteChangePopupService} routeChangePopupService
   * @param {PopupService} popupService
   * @memberof LmsTrainNotesComponent
   */
  constructor(private notesDataService: NotesDataService, configService: ConfigService, lmsMenuService: LmsMenuService, lmsModuleService: LmsModuleService, utilService: UtilService,
    editModeService: EditModeService, routeChangePopupService: RouteChangePopupService, popupService: PopupService) {
    super(configService, lmsMenuService, lmsModuleService, utilService, editModeService, routeChangePopupService, popupService);
    this.configdata = this.configService.getConfigData();
    this.service = this.notesDataService;
    this.type = this.configdata.menu.type.train;
    this.blankMessage = this.configdata.notesLabel.searchTrainNotes;
    this.errorMessage = this.configdata.messages.invalidTrainId;
  }

  /**
   * @memberOf LmsTrainNotesComponent
   */
  public search() {
    if (!this.isEditMode()) {
      this.selectedTab.mode = 'view';
      this.updateTab(this.selectedTab);
    }
    this.noteTextParent = '';
    this.notesDataService.load(this.selectedTab, 'LWTD', 'T');
  }

  /**
   * @memberOf LmsTrainNotesComponent
   */
  ngOnInit() {
    super.init(this.search);
  }

  ngOnDestroy() {
    super.destroy();
  }

}
